/**
 * @flow
 */

import React, { useContext, useRef, useLayoutEffect } from "react"
import _ from "lodash"
import styled from "styled-components"

import { ScrollerContext } from "../elements/SmoothScroll/context"

type Props = {
  src: string,
  width: number,
  height: number,
}

const Container = styled.div`
  width: ${props => `${props.width}px`};
  /* height: ${props => `${props.height}px`}; */
  max-width: 100%;
  max-height: 100%;
  video {
    width: 100%;
    height: auto;
  }
`

const Video = ({ src, ...props }: Props) => {
  const context = useContext(ScrollerContext)

  const frameId = useRef(null)
  const containerEl = useRef(null)
  const videoEl = useRef(null)

  const onScroll = () => {
    let target = _.get(containerEl, "current").getBoundingClientRect().top
    let upperbound = window.innerHeight
    let lowerbound = _.get(containerEl, "current").getBoundingClientRect()
      .height

    /* determine if block is entering / leaving the viewport */
    if (target < upperbound && target > 0 - lowerbound) {
      if (_.get(videoEl, "current").paused) {
        _.get(videoEl, "current").play()
      }
    } else {
      if (!_.get(videoEl, "current").paused) {
        _.get(videoEl, "current").pause()
      }
    }
    /* recall RAF whilst scrolling is still taking place */
    if (frameId.current && context.isScrolling) {
      frameId.current = window.requestAnimationFrame(onScroll)
    }
  }

  useLayoutEffect(() => {
    if (context.isScrolling) {
      frameId.current = window.requestAnimationFrame(onScroll)
    } else {
      window.cancelAnimationFrame(frameId.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.isScrolling])

  return (
    <Container ref={containerEl} {...props}>
      <video muted="muted" loop="loop" playsInline ref={videoEl}>
        <source src={src} type="video/mp4" />
      </video>
    </Container>
  )
}

export default Video
